import { render } from "./Opportunities.vue?vue&type=template&id=05ea1e06&scoped=true"
import script from "./Opportunities.vue?vue&type=script&lang=js"
export * from "./Opportunities.vue?vue&type=script&lang=js"

import "./Opportunities.vue?vue&type=style&index=0&id=05ea1e06&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05ea1e06"]])

export default __exports__